import './FilterList.scoped.scss'
import { isMobile } from 'react-device-detect'
import { trackEvent } from 'Shared/lib/posthog'

const GROUP_DESCRIPTIONS = {
  engagement: {
    slug: 'engagement-filters',
    tip: 'You can use these filters to find supporters who are more or less likely to engage with your text messages, WhatsApps, and emails. Active supporters do not include people taking their first action.'
  }
}

export default function FilterList({ groupId, close }) {
  const act = useAct()
  const [groupIndex, setGroupIndex] = useState(isMobile ? null : 0)

  const availableFilters = useSel((s) => s.availableFilters)
  const visibleFilters = Object.values(availableFilters).filter(
    (filter) => !filter.presentation.hidden
  )
  const featuredCustomFields = useSel(s => s.local.featuredCustomFields || [])
  const featuredCustomFieldsFilters = featuredCustomFields.map((cf) => ({
    customFieldId: cf.id,
    kind: cf.kind,
    presentation: {
      id: 'featuredCustomField',
      name: cf.name,
      group: 'Quick',
      hidden: false,
    },
  }))

  // Expand filters with modes into separate menu entries
  const expandedVisibleFilters = visibleFilters.flatMap((filter) => {
    if (filter.modes && filter.modes.length > 0) {
      return filter.modes.map((mode) => ({
        ...filter,
        _mode: mode,
        presentation: {
          ...filter.presentation,
          name: mode.name,
          group: mode.group || filter.presentation.group,
        },
      }))
    }
    return [filter]
  })

  const allFilters = [
    ...expandedVisibleFilters,
    ...featuredCustomFieldsFilters
  ]

  // group filters into categories
  // sort  both group + filter names alphabetically
  const filterGroups = [
    // First, find and extract the 'Quick' category if it exists
    ..._.sortBy(
      _.uniqBy(
        allFilters.map((filter) => ({
          name: filter.presentation.group,
          description: null,
        })),
        'name'
      ).map((group) => ({
        ...group,
        filters: _.sortBy(
          allFilters.filter((filter) => filter.presentation.group === group.name),
          (filter) => filter.presentation.name
        ),
      })),
      (group) => (group.name === 'Quick' ? -1 : group.name)
    ),
  ]

  const GroupSelection = () => (
      <div className="group-names">
        <div className='close-modal popover-modal-visible' onClick={() => close()}>
          <SvgIconsCross />
        </div>
        <div className='filter-help-text bold dark-grey no-margin group-deselect'  onClick={() => close()}>
          <SvgIconsCross />
          <span>Close Filter Selection</span>
        </div>
        {filterGroups.map((group, i) => {
          return (
            <div
              key={i}
              className={`${groupIndex === i ? 'active' : ''} ${i === 0 ? 'first' : ''}`}
              onClick={() => setGroupIndex(i)}
            >
              <h5>
                {group.name === 'Quick' && <SvgIconsStar width={16} height={16} />}
                {group.name}
                {groupIndex === i && <SvgIconsArrowRight />}
              </h5>
              {group.description && <p>{group.description}</p>}
            </div>
          )
        })}
      </div>)

  if (groupIndex === null) {
    return (
      <div className="popup">
        <GroupSelection />
      </div>
    )
  }

  const filters = filterGroups[groupIndex]?.filters
  if (!filters) return null // race can mean that the group is not yet loaded
  const currentGroupName = filterGroups[groupIndex]?.name?.toLowerCase()
  const groupDescription = GROUP_DESCRIPTIONS[currentGroupName]

  function addFilter(filter) {
    const id = filter.presentation.id
    if (id === 'featuredCustomField') {
      const filterType = filter.kind === 'float' ? 'numberCustomField' : 'customField'
      act.search.addFilter({ parentRuleId: groupId, filter: filterType, parameters: { customFieldId: filter.customFieldId } })
    } else if (filter._mode) {
      const defaults = { ...filter._mode.defaults }
      const ruleOverrides = {}
      if (defaults.not !== undefined) {
        ruleOverrides.not = defaults.not
        delete defaults.not
      }
      act.search.addFilter({ parentRuleId: groupId, filter: id, parameters: defaults, ruleOverrides })
    } else {
      act.search.addFilter({ parentRuleId: groupId, filter: id })
    }
    trackEvent('audience_builder_added_rule', {
      type: 'filter',
      filterId: id,
    })
  }

  return (
    <div className={`popup group-selected`}>
      <GroupSelection />
      <div className="group-filters">
        <div className='filter-help-text bold dark-grey no-margin group-deselect'  onClick={() => setGroupIndex(null)}>
          <SvgIconsArrowLeft />
          <span>Back to filter groups</span>
        </div>
        {groupDescription && (
          <p className='filter-help-text bold dark-grey no-margin'>{groupDescription.tip}</p>
        )}
        {filters.map((filter) => {
          return (
            <div
              key={filter.presentation.name}
              className="filter"
              onClick={() => {
                addFilter(filter)
                close()
              }}
            >
              {filter.presentation.name}
            </div>
          )
        })}
      </div>
    </div>
  )
}